// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg fill=%27%23333%27 height=%2716%27 viewBox=%270 0 24 24%27 width=%2716%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M7 10l5 5 5-5z%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PractitionerDropdown.css */

.practitioner-dropdown-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  
  .practitioner-dropdown-container label {
    font-weight: 600;
    color: #333;
  }
  
  .practitioner-dropdown-container select {
    width: 100%;
    padding: 10px 14px;
    font-size: 1rem;
    border: 1px solid #ccc;
    border-radius: 6px;
    background-color: #fff;
    appearance: none;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 12px center;
    background-size: 16px;
  }
  
  .practitioner-dropdown-container select:focus {
    border-color: var(--clr-primary-3);
    outline: none;
    box-shadow: 0 0 0 2px rgba(100, 150, 250, 0.2);
  }
  
  .practitioner-dropdown-container select:hover {
    cursor: pointer;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/AdminScheduling/SchedulingStyles/PractitionerDropdown.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,wDAAwD;IACxD,yDAAkL;IAClL,4BAA4B;IAC5B,sCAAsC;IACtC,qBAAqB;EACvB;;EAEA;IACE,kCAAkC;IAClC,aAAa;IACb,8CAA8C;EAChD;;EAEA;IACE,eAAe;EACjB","sourcesContent":["/* PractitionerDropdown.css */\n\n.practitioner-dropdown-container {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .practitioner-dropdown-container label {\n    font-weight: 600;\n    color: #333;\n  }\n  \n  .practitioner-dropdown-container select {\n    width: 100%;\n    padding: 10px 14px;\n    font-size: 1rem;\n    border: 1px solid #ccc;\n    border-radius: 6px;\n    background-color: #fff;\n    appearance: none;\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\n    background-image: url(\"data:image/svg+xml;utf8,<svg fill='%23333' height='16' viewBox='0 0 24 24' width='16' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>\");\n    background-repeat: no-repeat;\n    background-position: right 12px center;\n    background-size: 16px;\n  }\n  \n  .practitioner-dropdown-container select:focus {\n    border-color: var(--clr-primary-3);\n    outline: none;\n    box-shadow: 0 0 0 2px rgba(100, 150, 250, 0.2);\n  }\n  \n  .practitioner-dropdown-container select:hover {\n    cursor: pointer;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
